export const HeroVideo = ({ id, credit, creditUrl, title }) => {
  const src = `https://www.youtube.com/embed/${id}?autoplay=1&mute=1&loop=1&playlist=${id}&controls=0&modestbranding=1&playsinline=1&rel=0&disablekb=1&iv_load_policy=3`;
  return (
    <div className="absolute inset-0 pointer-events-none overflow-hidden" aria-hidden="true" data-testid="hero-video-bg">
      <iframe title={title} src={src} allow="autoplay; encrypted-media" tabIndex={-1}
        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[100vw] h-[177.78vw] min-h-full min-w-[56.25vh] border-0" />
      <div className="absolute inset-0 bg-gradient-to-r from-[#064D29]/85 via-[#064D29]/55 to-[#064D29]/25" />
      <div className="absolute bottom-3 right-4 font-data text-[9px] uppercase tracking-wider text-white/60 pointer-events-auto">
        Video: <a href={creditUrl} target="_blank" rel="noreferrer" className="hover:text-white" data-testid="hero-video-credit">{credit}</a>
      </div>
    </div>
  );
};
